import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersSlash } from "@fortawesome/free-solid-svg-icons";
import { getCreditsPendienteAsync } from "../../../api/Dashboard";
import { useDatoPanel } from "../useDatoPanel";
import KpiPanel from "./KpiPanel";

const PendieteCredits = () => {
  const [totalNoDesembolsado, setNoDesembolsado] = useState(0);
  const { cargando, error, recargar } = useDatoPanel(
    getCreditsPendienteAsync,
    (data) => setNoDesembolsado(data.result)
  );

  // Antes llevaba a /clients; los créditos pendientes de entrega están en la lista de créditos.
  return (
    <KpiPanel
      titulo="No Desembolsados"
      valor={totalNoDesembolsado}
      formato="entero"
      icono={<FontAwesomeIcon icon={faUsersSlash} style={{ fontSize: 22 }} />}
      tono="warning"
      cargando={cargando}
      error={error}
      onReintentar={recargar}
      destino="/credits"
      permiso="CREDITS VER"
      ayuda="Ver Créditos no Desembolsados"
    />
  );
};

export default PendieteCredits;
